/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { useHistory } from 'react-router-dom';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import InvoiceTabs from './invoiceTabs';
import {
  getHandlingCode,
  getInvoiceStatusCode,
  setSaveRequest,
  saveInvoiceDetails,
  getInvoiceDetailsByInvoiceNum,
  getAllCommonDropdownList,
  getInvoiceReasonList,
} from '../store/actions';
import * as CONSTANTS from '../../../../SharedModules/AppConstants';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import {
  closeTab,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  getCommonDropdownList,
  setSearchInvoiceAuditTab,
} from '../../../Research/InvoiceAudits/store/Actions';
import { getExistingCommentLinkIds } from '../../../../SharedModules/utilities/commonAPI';
import { getQuarterData } from '../../../Tasks/AllocatePayments/store/Actions';
import { getRebateProgramDropdownList } from '../../../Research/UnderThresholdInvoices/store/Actions';

function RequestInvoiceDetails() {
  const dispatch = useDispatch();
  const history = useHistory();

  const invoiceDetailsByInvoiceNum = useSelector(
    (state) =>
      state.sharedState.DisplayInvoiceReducer.invoiceDetailsByInvoiceNum?.data
  );
  const invoiceQuarter = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.invoiceQuarter
  );
  const handlingCodeValues = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.handlingCodeValues
  );
  const invoiceStatusCodeValues = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.invoiceStatusCodeValues
  );

  const saveRequestData = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.saveRequestData
  );

  const savedInvoiceDetails = useSelector(
    (state) => state?.sharedState?.DisplayInvoiceReducer?.savedInvoiceDetails
  );

  const invoiceNumber = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.invoiceNumber
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const setSearchInvoiceAudit = (value) =>
    dispatch(setSearchInvoiceAuditTab(value));
  const [fullScreenView, setFullScreenView] = useState(false);
  const [tabFullScreenView, setTabFullScreenView] = useState(false);
  const [isSaveClicked, setSaveClicked] = useState(false);
  const [successMessages, setSuccessMessages] = useState([]);
  const [openCancel, setOpenCancel] = useState(false);
  const [open, setOpen] = useState(false);
  const [dataToSave, setDataToSave] = useState([]);
  const [showComments, setShowComments] = useState(false);
  const [disableSaveAndCancelBtn, setDisableSaveAndCancelBtn] = useState(true);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = useState(false);
  const [ccCommentsExist, setCcCommentsExist] = useState(0);
  const [commonDropdownList, setCommonDropdownList] = React.useState({});
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [invoiceReasonList, setInvoiceReasonList] = React.useState([]);

  const state = {
    selectBy: 'A',
    auditTypeCd: 'ALL',
    quarterValue: invoiceDetailsByInvoiceNum?.qtr,
    selectedAuditType: '-1',
    clearedIndex: 0,
    searchTypeState: {
      valueSelectedRedux: 'NDC',
      ndcSearchTextRedux: '',
      ndcNameSearchTextRedux: '',
      ndcLeftTableDataRedux: [],
      ndcRightTableDataRedux: [],
      labelerTableDataRedux: [],
      ndcLeftSelectedRowsRedux: [],
      ndcRightSelectedRowsRedux: [],
      labelerSelectedRowRedux: '',
      ndcLeftFullScreenRedux: false,
      ndcRightFullScreenRedux: false,
      labelerFullScreenRedux: false,
    },
  };

  useEffect(() => {
    handleScrollToEvent();
    dispatch(getHandlingCode('INVOICE_HANDLING_CD'));
    dispatch(getInvoiceStatusCode('INVOICE_STATUS_CD'));
    dispatch(getQuarterData());
    getAllCommonDropdownList({
      codeDomainList: ['ACTIVITY_TYPE_CD', 'ADJUSTMENT_DISPUTE_CD'],
    }).then((res) => {
      setCommonDropdownList(res);
    });
    getInvoiceReasonList('INVOICE_REASON_CD').then((res) => {
      setInvoiceReasonList(res);
    });
    // if (!saveRequestData || Object.keys(saveRequestData).length === 0) {
      dispatch(setSaveRequest(invoiceDetailsByInvoiceNum));
    // }
    setSuccessMessages([]);
    setSearchInvoiceAudit({
      fullScreenView: fullScreenView,
      state: state,
    });
    dispatch(getCommonDropdownList(invoiceDetailsByInvoiceNum?.planTypeCode));
  }, [invoiceDetailsByInvoiceNum]);

  useEffect(() => {
    getExistingComments();
  }, [showComments]);

  const getExistingComments = async () => {
    const res = await getExistingCommentLinkIds([
      invoiceDetailsByInvoiceNum?.corrLinkId,
    ]);
    setCcCommentsExist(
      res?.includes(invoiceDetailsByInvoiceNum?.corrLinkId) ? 1 : 0
    );
  };

  useEffect(() => {
    if (savedInvoiceDetails?.status === '001' && isSaveClicked) {
      const invoiceNum =
        invoiceNumber || invoiceDetailsByInvoiceNum?.invoiceNum;
      if (invoiceNum) {
        dispatch(getInvoiceDetailsByInvoiceNum({ invoiceNum }));
      }
      if (clickOncloseTabBtn) {
        // dispatch(resetDisplayInvoiceStore());
        closeTab('/display-invoice', history, dispatch);
      }
      setSuccessMessages([CONSTANTS.SAVE_SUCCESS]);
      setDataToSave([]);
    }
  }, [savedInvoiceDetails]);

  useEffect(() => {
    if (_.isEqual(saveRequestData, invoiceDetailsByInvoiceNum)) {
      setDisableSaveAndCancelBtn(true);
    } else if (isSaveClicked) {
      setDisableSaveAndCancelBtn(true);
    } else if (saveRequestData == undefined) {
      setDisableSaveAndCancelBtn(true);
    } else {
      setDisableSaveAndCancelBtn(false);
    }
  }, [saveRequestData, invoiceDetailsByInvoiceNum]);

  // handing refresh functionality
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (saveRequestData && Object.keys(saveRequestData).length > 0) {
      const newObj =
        updateTabs?.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/display-invoice' && !disableSaveAndCancelBtn) {
            item.isFormDirty = true;
          } else if (item.navTo === '/display-invoice') {
            item.isFormDirty = false;
          }
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [disableSaveAndCancelBtn, saveRequestData]);

  // close popup on click button
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs?.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/display-invoice' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/display-invoice' && item.isFormSave) {
          item.isFormSave = false;
          setClickOncloseTabBtn(true);
          handleInvoiceSave();
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpenCancel = () => {
    dispatch(setSaveRequest(invoiceDetailsByInvoiceNum));
    setOpenCancel(true);
    setSuccessMessages([]);
  };

  const handleCancelClose = () => {
    setOpenCancel(false);
  };

  const resetChanges = () => {
    if (dataToSave && dataToSave.length > 0) {
      setDataToSave([]);
      dispatch(setSaveRequest(invoiceDetailsByInvoiceNum));
    }
  };

  // set common dropdown list after calling API service
  React.useEffect(() => {
    if (invoiceDetailsByInvoiceNum?.planTypeCode) {
      getRebateProgramDropdownList(
        invoiceDetailsByInvoiceNum?.planTypeCode
      ).then((res) => {
        let list = [];
        if (
          res?.status === constantMessageData.STATUS_MSG &&
          res?.message === constantMessageData.SUCCESS_MSG
        ) {
          if (!_.isEmpty(res.data)) {
            list = _.map(res.data, (val) => ({
              ...val,
              id: val.rebateProgramCd,
              name: `${val.rebateProgramCd} | ${val.shortDescr}`,
            }));
          }
        }
        setRebateProgramList(
          list.sort((key, val) =>
            key.name.toLowerCase().localeCompare(val.name.toLowerCase())
          )
        );
      });
    }
  }, [invoiceDetailsByInvoiceNum?.planTypeCode]);

  const handleInvoiceChangeValues = (e) => {
    if (e.target.name === 'holdForInvestigationInd') {
      dispatch(
        setSaveRequest({
          ...saveRequestData,
          holdForInvestigationInd: e.target.checked === true ? 1 : 0,
        })
      );
    } else {
      dispatch(
        setSaveRequest({ ...saveRequestData, [e.target.name]: e.target.value })
      );
    }
  };

  const handleInvoiceSave = () => {
    setSaveClicked(true);
    dispatch(saveInvoiceDetails(saveRequestData));
    handleClose();
    setDisableSaveAndCancelBtn(true);
  };

  const handleSaveOpenClcik = () => {
    setOpen(true);
    setSuccessMessages([]);
  };

  const getPlanTypeDescription = (planTypeCd) => {
    switch (planTypeCd) {
      case 'ST':
        return 'State';
      case 'FD':
        return 'Medicaid';
      case 'COMM':
        return 'Commercial';
      case 'SUPP':
        return 'Supplemental';
      default:
        return '';
    }
  };

  return (
    <>
      <div>
        <SaveCancelPopup
          open={open}
          title='Save'
          onConfim={() => {
            handleInvoiceSave();
          }}
          onCancel={() => {
            resetChanges();
            handleClose();
          }}
        />
        <SaveCancelPopup
          open={openCancel}
          title='Cancel'
          onConfim={() => {
            resetChanges();
            handleCancelClose();
          }}
          onCancel={() => {
            handleCancelClose();
          }}
        />
      </div>

      <div className='tBillPanel custom-check'>
        <div className='panel tBillPanel-space pb-0'>
          <Spinner load={spinnerLoader} />

          <CustomSeparator parent1='Display' parent2='Display Invoice' />
          <DisplaySuccessMessages successMessages={successMessages} />
          {!(fullScreenView || tabFullScreenView) && (
            <>
              <fieldset className='custom-fieldset'>
                <form autoComplete='off' tabIndex={'0'}>
                  <div className='form-wrapper form-wrapper-col-4'>
                    <div className='mui-custom-form input-md'>
                      <TextField
                        label='Invoice Number'
                        id='InvoiceNumber'
                        fullWidth
                        placeholder=''
                        disabled
                        value={invoiceDetailsByInvoiceNum?.invoiceNum}
                        onChange={() => {}}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          maxLength: 10,
                          id: 'InvoiceNumber',
                        }}
                      />
                    </div>
                    <div className='mui-custom-form input-md'>
                      <TextField
                        label='Manufacturer'
                        id='Manufacturer'
                        fullWidth
                        placeholder=''
                        disabled
                        value={invoiceDetailsByInvoiceNum?.mfgId}
                        onChange={() => {}}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          maxLength: 10,
                          id: 'Manufacturer',
                        }}
                      />
                    </div>
                    <div className='mui-custom-form input-md'>
                      <TextField
                        label='Quarter'
                        id='Quarter'
                        fullWidth
                        placeholder=''
                        disabled
                        value={invoiceDetailsByInvoiceNum?.qtr}
                        onChange={() => {}}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          maxLength: 10,
                          id: 'Quarter',
                        }}
                      />
                    </div>
                    <div className='mui-custom-form input-md'>
                      {invoiceDetailsByInvoiceNum?.mfgName?.length > 20 ? (
                        <OverlayTrigger
                          placement='bottom'
                          overlay={
                            <Tooltip id='com-tooltip'>
                              {invoiceDetailsByInvoiceNum?.mfgName}
                            </Tooltip>
                          }
                        >
                          <TextField
                            label='Manufacturer Name'
                            id='NameField'
                            fullWidth
                            placeholder=''
                            disabled
                            value={`${invoiceDetailsByInvoiceNum?.mfgName.substring(
                              0,
                              20
                            )} ...`}
                            onChange={() => {}}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              maxLength: 10,
                              id: 'NameField',
                            }}
                          />
                        </OverlayTrigger>
                      ) : (
                        <TextField
                          label='Name'
                          id='Name'
                          fullWidth
                          placeholder=''
                          disabled
                          value={invoiceDetailsByInvoiceNum?.mfgName}
                          onChange={() => {}}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{
                            maxLength: 10,
                            id: 'Name',
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <div className='form-wrapper form-wrapper-col-4'>
                    <div className='mui-custom-form input-md'>
                      <TextField
                        label='Plan Type'
                        id='PlanType'
                        fullWidth
                        placeholder=''
                        disabled
                        value={getPlanTypeDescription(
                          invoiceDetailsByInvoiceNum?.planTypeCode
                        )}
                        onChange={() => {}}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          maxLength: 10,
                          id: 'PlanType',
                        }}
                      />
                    </div>
                    <div className='mui-custom-form input-md'>
                      <TextField
                        label='Rebate Program'
                        id='RebateProgram'
                        fullWidth
                        select
                        disabled
                        placeholder=''
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ id: 'RebateProgram' }}
                        name='rebateProgramCode'
                        value={invoiceDetailsByInvoiceNum?.rebateProgramCd}
                      >
                        <MenuItem selected key='Please Select One' value='-1'>
                          Please Select One
                        </MenuItem>
                        {rebateProgramList?.length > 0
                          ? rebateProgramList?.map((item) => {
                              return (
                                <MenuItem
                                  key={item.rebateProgramCd}
                                  value={item.rebateProgramCd}
                                >
                                  {item.rebateProgramCd} | {item.shortDescr}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </div>
                    <div className='mui-custom-form input-md'>
                      <div className='comment-sec mt-26'>
                        Comments{' '}
                        {parseInt(ccCommentsExist, [0, 1]) === 1 ? (
                          <img
                            role='button'
                            onClick={() => {
                              setShowComments(true);
                            }}
                            tabIndex={'0'}
                            onKeyDown={(e) => {
                              // Handle Enter and Space key events
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault(); // Prevents the default space scrolling behavior
                                setShowComments(true);
                              }
                            }}
                            alt='comment'
                            src={CommentVisibleIcon}
                          />
                        ) : (
                          <img
                            role='button'
                            onClick={() => {
                              setShowComments(true);
                            }}
                            onKeyDown={(e) => {
                              // Handle Enter and Space key events
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault(); // Prevents the default space scrolling behavior
                                setShowComments(true);
                              }
                            }}
                            alt='comment'
                            tabIndex={'0'}
                            src={CommentIcon}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              </fieldset>
              <div className='btn-wrapper mb-2'>
                <div className='float-right mt-2 hide-on-print'>
                  <Button
                    className='btn btn-success btn-save'
                    onClick={handleSaveOpenClcik}
                    disabled={disableSaveAndCancelBtn}
                  >
                    {' '}
                    <SVGComponent iconName='Icon-awesome-save' /> Save
                  </Button>
                  <Button
                    className='btn btn-cancel'
                    onClick={handleClickOpenCancel}
                    disabled={disableSaveAndCancelBtn}
                  >
                    <SVGComponent iconName='Icon-cancel' />
                    Cancel
                  </Button>
                </div>
                <div className='clearfix' />
              </div>
            </>
          )}
          <InvoiceTabs
            key={invoiceDetailsByInvoiceNum?.invoiceNum}
            handleInvoiceChangeValues={handleInvoiceChangeValues}
            setFullScreenView={setFullScreenView}
            fullScreenView={fullScreenView}
            setTabFullScreenView={setTabFullScreenView}
            tabFullScreenView={tabFullScreenView}
            invoiceDetailsByInvoiceNum={invoiceDetailsByInvoiceNum}
            handlingCodeValues={handlingCodeValues}
            invoiceQuarter={invoiceQuarter}
            invoiceStatusCodeValues={invoiceStatusCodeValues}
            ccCommentsExist={ccCommentsExist}
            commonDropdownList={commonDropdownList}
            invoiceReasonList={invoiceReasonList}
          />
          {showComments ? (
            <CommentAndCorrespondenceComponent
              setShowComments={setShowComments}
              linkTableName='INVOICE_HEADER'
              corrLinkId={invoiceDetailsByInvoiceNum?.corrLinkId}
              rowGridPrimaryKey={invoiceDetailsByInvoiceNum?.invoiceNum}
            />
          ) : null}
        </div>
      </div>
    </>
  );
}
export default withRouter(RequestInvoiceDetails);
